<template>
  <div id="code-lab" :class="shit$(`w:100%; h:100%; absolute; top; left; overflow:h;`)">
      <svg-sprite />
      <router-view />
      <init-socket />
      <cookie-wall v-if="userId" :user-id="userId" prefix="develop-tool-codelab"></cookie-wall>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CookieWall from '../code-lab/component/cookie-wall/index'
import InitSocket from "@/service/webSocket/init-socket.js";
import svgSprite from "./component/svg-sprite.vue";
export default {
  components: { InitSocket, svgSprite,CookieWall },
  computed: {
    ...mapState('user', [
        'userId',
        'teamId',
        'token'
    ])
  },
  async created() {
    this.$store.commit("handleCurrentVersion", "public");
    this.updIntroState_()
  },
  methods: {
    updIntroState_ () {
      const arr = [ { key: 'missionDB', to: 'introStore/upLock' },  ]
      arr.forEach(({ key, to }) => this.$store.commit(to, [ Boolean(localStorage.getItem(key)), key ]) )
    }
  }
};
</script>

<style lang="scss">
.el-dialog__wrapper {
  background-color: $--codelab-primary-black-4;
}
.el-message-box__wrapper {
  background-color: $--codelab-primary-black-4;
  padding-bottom: 30vh;
}
.socketErrorCodeClass_g {
  padding-right: 30px!important;
  min-width: 100px;
}

</style>
